import React from "react";
import classes from "./Leadership.module.css";
import Divider from "../../../components/Divider/Divider";
import Input from "../../../components/Input/Input";
import PrimaryButton from "../../../components/Buttons/PrimaryButton";
import LeadershipVoicesBanner from "./LeadershipVoicesBanner/LeadershipVoicesBanner";
import principalVoiceBanner from "../../../assets/images/principalVoiceBanner.jpg";
import podcastBanner4 from "../../../assets/images/podcastbanner4.jpg";
import podcastBanner5 from "../../../assets/images/podcastbanner5.jpg";
import principalVoiceBannerMobile from "../../../assets/images/principalVoiceBanner_mobile.jpg";
import podcastBanner4Mobile from "../../../assets/images/podcastbanner4_mobile.jpg";
import podcastBanner5Mobile from "../../../assets/images/podcastbanner5_mobile.jpg";
import PodcastCTA from "./PodcastCTA/PodcastCTA";
import MainFooter from "../../../components/MainFooter/MainFooter";
import Utils from "../../../Utils";
import { createPodcastRegistration } from "../PodcastsAction";
import toast from "react-hot-toast";

const formatKey = (key) =>
  key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase());

function Leadership() {
  const scrollToPodcastSection = () => {
    const element = document.getElementById("book-a-podcast");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    try {
      const res = await createPodcastRegistration(data);
      if (res.data.success) {
        toast.success(
          "Thank You for Registering! 🎙️ Welcome to the Bookalooza Podcast! we'll call you soon."
        );
      }
    } catch (error) {
      toast.error("Oops! may be you already registered.");
    }
  };

  return (
    <>
      <div className={classes.main}>
        <section className={classes.heroSection}>
          <div className={classes.container}>
            <div className={classes.heroContent}>
              <div className={classes.heroText}>
                <h1 className={classes.heroTitle}>
                  <span>Your Story, Your Impact –</span>
                  <span>A Podcast Just for Principals!</span>
                </h1>
                <Divider />
                <h2 className={classes.heroSubTitle}>Stories have power.</h2>
                <p>
                  They shape perspectives, challenge norms, and ignite change.
                  As a school principal, your story matters. Your leadership,
                  challenges, and triumphs deserve to be heard.
                </p>
                <p>
                  That’s why Bookalooza created{" "}
                  <b>Voice of Leadership—A Podcast for Principals.</b> A space
                  where education leaders like you share insights, inspire
                  change and leave a lasting impact. And the best part? It’s
                  completely free. <b>No cost—just impact</b>.
                </p>
              </div>
              <div className={classes.heroFormContainer}>
                <div className={classes.heroForm}>
                  <h2>
                    <span>Book your exclusive</span>{" "}
                    <span>Podcast with us</span>
                  </h2>
                  <p>
                    Do not miss your chance. Fill out the form below and let’s
                    get started.
                  </p>
                  <form className={classes.form} onSubmit={handleSubmit}>
                    {["name", "city", "phoneNumber", "email", "schoolName"].map(
                      (placeholder) => (
                        <Input
                          key={placeholder}
                          type="text"
                          name={placeholder.toLowerCase()}
                          placeholder={`Enter ${formatKey(placeholder)}`}
                          required
                        />
                      )
                    )}
                    <PrimaryButton type="submit">Register Now</PrimaryButton>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <artical>
          <div className={Utils.getClasses(classes.container, classes.content)}>
            <h2>Your Story Matters. Voice of Leadership</h2>
            <p>
              Stories shape perspectives, challenge norms, and ignite change. As
              a school principal, you’re not just leading an institution—you’re
              shaping futures, inspiring young minds, and driving transformation
              in education. But here’s the question—who’s telling your story?
            </p>
            <p>
              At the Voice of Leadership Podcast, we bring education leaders
              into the limelight—where their journeys, challenges, and victories
              get the stage they truly deserve. This is your chance to share
              your leadership vision, inspire fellow educators, and leave a
              lasting impact beyond your school walls.
            </p>
          </div>
        </artical>
        <div className={classes.principalVoice}>
          <picture>
            <source
              media="(max-width: 768px)"
              srcSet={principalVoiceBannerMobile}
            />
            <source media="(min-width: 769px)" srcSet={principalVoiceBanner} />
            <img
              src={principalVoiceBanner}
              alt={principalVoiceBanner}
              loading="lazy"
            />
          </picture>
        </div>
        <artical>
          <div className={Utils.getClasses(classes.container, classes.content)}>
            <h2>What’s holding you back for the Podcast?</h2>
            <ul>
              {[
                "You shape young minds daily, but your voice is limited to staff meetings and school events.",
                "You have valuable leadership lessons, but no platform to share them",
                "You want to make an impact beyond your school walls, but traditional media overlooks educators.",
              ].map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p>
              Meanwhile, business leaders, authors, and influencers are using
              podcasts to establish authority. Why shouldn’t principals do the
              same?
            </p>
            <PrimaryButton onClick={scrollToPodcastSection}>
              Book your Podcast Now!
            </PrimaryButton>
          </div>
        </artical>
        <LeadershipVoicesBanner />
        <artical>
          <div className={Utils.getClasses(classes.container, classes.content)}>
            <h2>Your Voice. Your Vision. Your Impact.</h2>
            <p>
              As a school leader, <b>you shape minds every day</b>. Now, let the
              world hear your journey through the <b>Voice of Leadership</b>{" "}
              Podcast—a platform designed to amplify <b>your message.</b>
            </p>
            <h2>Why You Should Join?</h2>
            <ul>
              <li>
                <b>Seamless Studio Experience</b>– We handle the tech, you focus
                on the message.
              </li>
              <li>
                <b>Expert-Driven Interview</b> – We bring out the best in your
                story.
              </li>
              <li>
                <b>No Cost, Maximum Reach</b> – A free platform for education
                leaders.
              </li>
              <li>
                <b>Share Your Leadership Insights</b> – Inspire thousands with
                your wisdom.
              </li>
            </ul>
            <p>
              The world needs strong voices in education. Let yours be one of
              them!
            </p>
            <PrimaryButton onClick={scrollToPodcastSection}>
              Book your Podcast Now!
            </PrimaryButton>
          </div>
        </artical>
        <div className={classes.principalVoice}>
          <a
            rel="noreferrer"
            href="https://www.youtube.com/watch?v=ETCbb3z9Qtg&list=PLB9Xyy1AsZuVM9DxPtROCfzII5UP8aill"
            target="_blank"
          >
            <picture>
              <source
                media="(max-width: 768px)"
                srcSet={podcastBanner4Mobile}
              />
              <source media="(min-width: 769px)" srcSet={podcastBanner4} />
              <img src={podcastBanner4} alt={podcastBanner4} loading="lazy" />
            </picture>
          </a>
        </div>
        <artical>
          <div className={Utils.getClasses(classes.container, classes.content)}>
            <h2>
              Why Principals Are Saying ‘Yes’ to Going Live on This Podcast
            </h2>
            <p>
              Education needs strong voices, and The{" "}
              <b>Voice of Leadership Podcast</b>
              is where principals are stepping up and making an impact—LIVE!
            </p>
            <p>
              This is your chance to share your journey, inspire change, and
              reach beyond your school community in real time. Principals who
              have joined us are already seeing their message create ripples
              across the education world.
            </p>
            <p>
              Now, it’s your turn. Come live, share your story, and lead the
              conversation!
            </p>
            <PrimaryButton>Watch Now</PrimaryButton>
          </div>
        </artical>
        <div className={classes.principalVoice}>
          <div>
            <picture>
              <source
                media="(max-width: 768px)"
                srcSet={podcastBanner5Mobile}
              />
              <source media="(min-width: 769px)" srcSet={podcastBanner5} />
              <img src={podcastBanner5} alt={podcastBanner5} loading="lazy" />
            </picture>
          </div>
        </div>
        <artical>
          <div className={Utils.getClasses(classes.container, classes.content)}>
            <h2>Your Voice Deserves to Be Heard — Book Your Podcast Today!</h2>
            <p>
              Education is more than just classrooms and curriculums—it’s about
              <b>inspiration, leadership, and impact</b>. And who better to
              shape the future of education than <b>you?</b>
            </p>
            <p>
              <b>The world needs to hear your story.</b> Your insights can{" "}
              <b>
                motivate educators, empower students, and drive real change.
              </b>
            </p>
            <p>
              Now’s your chance to step beyond the school walls and{" "}
              <b>lead the conversation.</b> Join us on the{" "}
              <b>Voice of Leadership</b> Podcast—where education leaders like
              you share their journey, vision, and ideas for the future.
            </p>
            <p>
              <b>Don’t wait—lead the conversation! Limited slots available!</b>
            </p>
            <PrimaryButton onClick={scrollToPodcastSection}>
              Reserve Your Spot Now{" "}
            </PrimaryButton>
          </div>
        </artical>
        <PodcastCTA formatKey={formatKey} handleSubmit={handleSubmit} />
        <artical>
          <div className={Utils.getClasses(classes.container, classes.content)}>
            <h2>Don’t Just Lead—Inspire.</h2>
            <p>
              Your journey as an education leader holds the power to shape minds
              beyond your school walls. <b>The Voice of Leadership Podcast</b>{" "}
              is your chance to share your vision, challenges, and triumphs—
              <b>
                impacting thousands of educators, students, and future leaders.
              </b>
            </p>
            <ul>
              {[
                "Inspire fellow educators",
                "Highlight your school’s achievements",
                "Shape the future of education",
              ].map((item, index) => (
                <li key={index}>
                  <b>{item}</b>
                </li>
              ))}
            </ul>
            <p>Your Story. Leave a Legacy</p>
          </div>
        </artical>
      </div>
      <MainFooter />
    </>
  );
}

export default Leadership;
